module.exports = __webpack_public_path__ + "static/icon2.png";